import React from 'react';
import styled from 'styled-components';
import { Button } from '../Button/Button';
import { Flex } from '../Flex/Flex';
import { applyVariations } from '../utils/utils';
const TransparentButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "IconButton__TransparentButton",
  componentId: "sc-z765t2-0"
})(["padding:0;background-color:transparent;color:inherit;&:hover{background-color:transparent;color:inherit;}& > div{display:flex;}&:disabled{background-color:transparent;}", ""], applyVariations('IconButton'));
/**
 * @public
 */
export const IconButton = React.forwardRef(({
  icon,
  ...props
}, ref) => {
  return React.createElement(TransparentButton, {
    ...props,
    ref: ref
  }, React.createElement(Flex, null, icon));
});
IconButton.displayName = 'IconButton';
// @ts-ignore
IconButton.isIconButton = true;